import React, { useContext, useEffect } from 'react';
import './PowerBi.scss';
import MyContext from '../../Context/MyContext';
import { PieChart, Pie, Cell, Tooltip } from 'recharts';


const PowerBi = () => {
 

  const{work,token,fetchwork,handleNavClick} = useContext(MyContext)


  useEffect(() => {
if(token){
    fetchwork();
}
  }, []);

  const pendingTasks = work.filter((c) => !c.comment);
  const completedTasks = work.filter((c) => c.comment);

  const taskData = [
    { name: 'Completed', value: completedTasks?.length, color: '#4caf50' },
    { name: 'In Progress', value: 30, color: '#ffc107' },
    { name: 'Pending', value: pendingTasks?.length, color: '#f44336' },
  ];

  return (
    <div className="right-main">
      <div className="header">
        <h2>Work Status Dashboard</h2>
        <p>Get a quick overview of work completion and progress.</p>
      </div>
      <div className="chart-container">
      
      <PieChart width={150} height={150}>
      <Pie
        data={taskData}
        dataKey="value"
        nameKey="name"
        cx="50%"
        cy="50%"
        outerRadius={50}
        innerRadius={30} 
        paddingAngle={5} 
       
      >
            {taskData.map((entry, index) => (
              <Cell key={`cell-${index}`} fill={entry.color} />
            ))}
          </Pie>
          <Tooltip />
         
        </PieChart>
      </div>
      <div className="stats">
        <div className="stat">
          <h5>Total Works</h5>
          <p>{work.length}</p>
        </div>
        <div className="stat" onClick={()=>handleNavClick('/work-completed')}>
          <h5>Completed Works</h5>
          <p style={{color:'#4caf50'}}>{completedTasks?.length}</p>
        </div>
        <div className="stat" onClick={()=>handleNavClick('/my-works')}>
          <h5>Pending Works</h5>
          <p style={{color:'red'}}>{pendingTasks?.length}</p>
        </div>
        <div className="stat">
          <h5>In Progress Works</h5>
          <p style={{color:'#ffc107'}}>30</p>
        </div>
      </div>
    </div>
  );
};

export default PowerBi;
